import {
    safeSessionGet,
    safeSessionRemove,
    safeSessionSet,
} from "@wags/tanstack-start/browser";

const KEY_FIRST_SAVE_FIRED = "wags_first_save_fired";

export function isFirstSaveThisSession(): boolean {
    if (safeSessionGet(KEY_FIRST_SAVE_FIRED)) return false;
    safeSessionSet(KEY_FIRST_SAVE_FIRED, "1");
    return true;
}

export function resetSaveTrigger(): void {
    safeSessionRemove(KEY_FIRST_SAVE_FIRED);
}
